import styled from 'styled-components';

export const SidebarOv = styled.div`
  width: 385px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 12px 16px 20px;
  gap: 10px;
  background: #0c1a16;
  border-right: 1px solid #182828;

  &::-webkit-scrollbar {
    width: 14px;
    height: 14px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.18);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.32);
    border-radius: 7px;
    border: 3px solid transparent;
    background-clip: padding-box;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
    background-clip: padding-box;
  }
`;
